import React, { Component } from "react";
import "./style.scss";
import { Helmet } from "react-helmet";

class Formations extends Component {
  render() {
    return (
      <div className="page Formations">
        <Helmet>
          <title>Tanguy HELLER | Formations</title>
        </Helmet>

        <div className="section">
          <div className="presentoir-wrapper">
            <div className="date">Ecole IPI - 2019</div>
            <div className="presentoir">
              <a href="https://www.ipi-ecoles.com/category/campus/toulouse/">
                <img src="/images/ipi-logo.png" alt="ipi-logo" />
              </a>
              <div className="text-section">
                <h2>
                  Master chef de projet informatique et ingénierie logicielle
                </h2>
                <p>
                  Au cours de mes 2 ans de formations en alternance j'ai étudié
                  la gestion de projet : gestion d'équipe, méthode Agile, SCRUM,
                  cycle de développement, budget. J'ai également étudié de la
                  techniques avec les langages C#, Javascript ainsi que .NET,
                  Node.js et la mise en place DevOps.
                </p>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div className="section">
          <div className="presentoir-wrapper">
            <div className="date">Ecole IPI - 2017</div>
            <div className="presentoir">
              <a href="https://www.ipi-ecoles.com/category/campus/toulouse/">
                <img src="/images/ipi-logo.png" alt="ipi-logo" />
              </a>
              <div className="text-section">
                <h2>Licence de concepteur / développeur informatique</h2>
                <p>
                  Au cours de mon année de formation en alternance j'ai étudié
                  la conception d'applications : design pattern, bonnes
                  pratiques, cycle de développement & tests. J'ai également
                  étudié les langages HTML, CSS, Javascript, JAVA et le
                  développement Android.
                </p>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div className="section">
          <div className="presentoir-wrapper">
            <div className="date">IUT Blagnac - 2016</div>
            <div className="presentoir">
              <a href="https://www.iut-blagnac.fr/fr">
                <img
                  src="/images/IUT-Blagnac-Universite-Toulouse-Jean-Jaures-1.png"
                  alt="iut-logo"
                />
              </a>
              <div className="text-section">
                <h2>DUT Informatique</h2>
                <p>
                  Au cours de mes 2 ans de formation, j'ai appris la POO avec le
                  langage JAVA. J'ai étudié les langages du web avec HTML, CSS,
                  PHP, Javascript et la gestion de base de données SQL. Ainsi
                  que l'algorithmie générale, le binaire, le PYTHON, le C et le
                  fonctionnement d'un ordinateur.
                </p>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div className="section">
          <div className="presentoir-wrapper">
            <div className="date">Lycée Ozenne - 2014</div>
            <div className="presentoir">
              <a href="https://ozenne.mon-ent-occitanie.fr/">
                <img
                  src="/images/Academie-de-toulouse-logo.png"
                  alt="ac-tlse-logo"
                />
              </a>
              <div className="text-section">
                <h2>BAC S, option ISN</h2>
                <p>
                  Grâce à l'option ISN (Informatique & Science du Numérique)
                  j'ai pu découvrir les bases de la programmation avec des
                  langages comme le html et le Java. Pour le projet de fin
                  d'année j'ai réalisé un jeu de plateforme en C en équipe de 3.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Formations;
